export default "__VITE_ASSET__CGuX8Tqn__"